// extracted by mini-css-extract-plugin
export default {"scroll":"AppointmentCategories_scroll__di3XQ"};